module.exports = __webpack_public_path__ + "img/arrow1.81ada482.svg";